// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Login_background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login-module__containerLogin___cJDX1 {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    background-size: cover;
    position: relative;
    flex-direction: column;
}

.Login-module__formWrapper___xEXER {
    position: relative;
    width: 100%;
    max-width: 600px;
}

.Login-module__formContainerLogin___UumAR {
    width: 100%;
    padding: 2rem;
    margin-bottom: 15px;
    text-align: left;
}

.Login-module__fieldContainer___AfTkJ {
    background: white;
    border: 1px solid #e0e0e0;
    padding: 8px 12px;
    margin-bottom: 1rem;
    width: 100%;
}

.Login-module__fieldLabelInner___xyohy {
    display: block;
    color: #666;
    font-size: 12px;
    margin-bottom: 2px;
}

.Login-module__inputLogin___AhJpA {
    width: 100%;
    border: none;
    font-size: 16px;
    color: #333;
    background: transparent;
    padding: 0;
}

textarea:focus, input:focus {
    outline: none;
}

.Login-module__inputLogin___AhJpA:hover {
    cursor: text;
}

.Login-module__buttonContainerLogin___BL_8y {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    position: relative; 
}

.Login-module__buttonLogin___rNRwz {
    padding: 5px 10px;
    background-color: var(--bmo-primary-color-mint);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    width: 100%;
    max-width: 150px;
    font-weight: bold;
    font-size: xx-large;
}

    .Login-module__buttonLogin___rNRwz:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

.Login-module__errorContainer___AgVxg {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: calc(100% + 20px); 
    width: auto; /* Allow width to be determined by content */
    white-space: nowrap; 
}

.Login-module__errorMessage___PUTMo {
    background-color: #ffebee;
    color: #c62828;
    padding: 12px 24px;
    border-radius: 4px;
    text-align: center;
    border: 1px solid #ef9a9a;
    font-size: 14px;
    display: inline-block; /* Allow the container to shrink to content */
}
`, "",{"version":3,"sources":["webpack://./app/styles/Login.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,2EAAyE;IACzE,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,+CAA+C;IAC/C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;IAEI;QACI,oDAAoD;IACxD;;AAEJ;IACI,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW,EAAE,4CAA4C;IACzD,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,qBAAqB,EAAE,6CAA6C;AACxE","sourcesContent":[".containerLogin {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-grow: 1;\n    background: url('../images/Login_background.jpg') no-repeat center center;\n    background-size: cover;\n    position: relative;\n    flex-direction: column;\n}\n\n.formWrapper {\n    position: relative;\n    width: 100%;\n    max-width: 600px;\n}\n\n.formContainerLogin {\n    width: 100%;\n    padding: 2rem;\n    margin-bottom: 15px;\n    text-align: left;\n}\n\n.fieldContainer {\n    background: white;\n    border: 1px solid #e0e0e0;\n    padding: 8px 12px;\n    margin-bottom: 1rem;\n    width: 100%;\n}\n\n.fieldLabelInner {\n    display: block;\n    color: #666;\n    font-size: 12px;\n    margin-bottom: 2px;\n}\n\n.inputLogin {\n    width: 100%;\n    border: none;\n    font-size: 16px;\n    color: #333;\n    background: transparent;\n    padding: 0;\n}\n\ntextarea:focus, input:focus {\n    outline: none;\n}\n\n.inputLogin:hover {\n    cursor: text;\n}\n\n.buttonContainerLogin {\n    display: flex;\n    justify-content: center;\n    margin-top: 50px;\n    position: relative; \n}\n\n.buttonLogin {\n    padding: 5px 10px;\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    width: 100%;\n    max-width: 150px;\n    font-weight: bold;\n    font-size: xx-large;\n}\n\n    .buttonLogin:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n.errorContainer {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    top: calc(100% + 20px); \n    width: auto; /* Allow width to be determined by content */\n    white-space: nowrap; \n}\n\n.errorMessage {\n    background-color: #ffebee;\n    color: #c62828;\n    padding: 12px 24px;\n    border-radius: 4px;\n    text-align: center;\n    border: 1px solid #ef9a9a;\n    font-size: 14px;\n    display: inline-block; /* Allow the container to shrink to content */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerLogin": `Login-module__containerLogin___cJDX1`,
	"formWrapper": `Login-module__formWrapper___xEXER`,
	"formContainerLogin": `Login-module__formContainerLogin___UumAR`,
	"fieldContainer": `Login-module__fieldContainer___AfTkJ`,
	"fieldLabelInner": `Login-module__fieldLabelInner___xyohy`,
	"inputLogin": `Login-module__inputLogin___AhJpA`,
	"buttonContainerLogin": `Login-module__buttonContainerLogin___BL_8y`,
	"buttonLogin": `Login-module__buttonLogin___rNRwz`,
	"errorContainer": `Login-module__errorContainer___AgVxg`,
	"errorMessage": `Login-module__errorMessage___PUTMo`
};
export default ___CSS_LOADER_EXPORT___;
